import { Modal, Typography } from "antd";
import Img from "assets/images";

const PRODUCT_OPTIONS = [
  {
    value: "ALL",
    label: "Tất cả sản phẩm",
    desc: "Áp dụng cho tất cả sản phẩm trong hệ thống",
    icon: Img.ImageGroupSeller,
  },
  {
    value: "INCLUDED",
    label: "Sản phẩm cụ thể",
    desc: "Chỉ áp dụng cho các sản phẩm được chọn",
    icon: Img.ImageSpecificSeller,
  },
  {
    value: "EXCLUDED",
    label: "Không bao gồm sản phẩm đã chọn",
    desc: "Áp dụng cho tất cả sản phẩm ngoại trừ các sản phẩm được chọn",
    icon: Img.ImageSellerVoucher,
  },
];

export const ProductTargetModal = ({ visible, onCancel, onSelect, currentType }) => {
  const handleSelect = (value) => {
    onSelect?.(value);
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={520}
      title={<span style={{ fontWeight: 700, fontSize: 15 }}>Chọn loại sản phẩm áp dụng</span>}
      bodyStyle={{ padding: "13px" }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        {PRODUCT_OPTIONS.map((option) => {
          const isSelected = currentType === option.value;

          return (
            <div key={option.value}>
              <div
                onClick={() => handleSelect(option.value)}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  background: isSelected ? "#EEF4FF" : "#fff",
                  borderRadius: 12,
                  padding: "10px 16px",
                  cursor: "pointer",
                  transition: "background 0.2s",
                  border: isSelected ? "1px solid #2246DC" : "1px solid transparent",
                }}
              >
                <span style={{ fontSize: 24, marginRight: 16, flexShrink: 0 }}>
                  <img src={option.icon} alt="" width={24} />
                </span>
                <div style={{ flex: 1 }}>
                  <Typography.Text
                    style={{
                      fontWeight: 700,
                      fontSize: 13,
                      color: isSelected ? "#2246DC" : "#101828",
                    }}
                  >
                    {option.label}
                  </Typography.Text>
                  <div style={{ color: "#667084", fontSize: 12, marginTop: 4 }}>{option.desc}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
};

export default ProductTargetModal;
